import { MbscCalendarInvalid } from '@mobiscroll/react';
import { DateTime } from 'luxon';

import { DispatchAssignmentRead } from 'src/common/external/bambi-api/bambiApi';

export function createInvalidsFromAssignments(
  assignments: DispatchAssignmentRead[]
): MbscCalendarInvalid[] {
  const invalids: MbscCalendarInvalid[] = [];

  assignments.forEach((assignment) => {
    const timeBeforeShift = {
      start: DateTime.fromISO(assignment.start)
        .startOf('day')
        .toUTC()
        .toJSDate(),
      end: DateTime.fromISO(assignment.start).toUTC().toJSDate(),
      resource: assignment.id,
    } as MbscCalendarInvalid;
    invalids.push(timeBeforeShift);

    const timeAfterShift = {
      start: DateTime.fromISO(assignment.end).toUTC().toJSDate(),
      end: DateTime.fromISO(assignment.end).endOf('day').toUTC().toJSDate(),
      resource: assignment.id,
    } as MbscCalendarInvalid;
    invalids.push(timeAfterShift);
  });

  return invalids;
}
